import React from 'react'
import { useWalletContext } from 'hooks/context'
import { toLower } from 'lodash-es'
import { Box, ImageIcon, Text } from '@node-space/storybook-components'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { useAccountPreferencesQuery } from 'hooks/queries/useAccountPreferencesQuery'
import SafeGuardIcon from 'components/wallets/SafeguardIcon'
import { formatTotal } from 'pages/Wallets/components/Table/utils'

type WalletBalanceProps = {
  isEmoney: boolean
}

export const WalletBalance = ({ isEmoney }: WalletBalanceProps) => {
  const wallet = useWalletContext()
  const { profile: { currencyCode: baseCurrency } = {} } = useProfileContext()
  const { data: accountPreferences } = useAccountPreferencesQuery()

  const preferredCurrency = accountPreferences?.currency
  const userCurrency = preferredCurrency || baseCurrency
  const walletCurrency = wallet?.currency?.code
  const walletBalance = wallet?.approxBalance
  const walletConvertedAvailable = wallet?.approxConvertedAvailable

  return (
    <>
      <Box flex alignItems="center" gap={12} className="relative">
        {walletCurrency && (
          <ImageIcon
            width={32}
            height={32}
            src={`${process.env.ICONS_URL}${toLower(walletCurrency)}.svg`}
          />
        )}
        {isEmoney && <SafeGuardIcon isDetails={true} />}
        <Text size="3xl" weight="semibold" color="dark-grey">
          {!Number(walletBalance)
            ? `${walletBalance} ${walletCurrency}`
            : formatTotal(Number(walletBalance), walletCurrency)}
        </Text>
      </Box>
      {walletCurrency !== baseCurrency && Boolean(Number(walletConvertedAvailable)) && (
        <Text size="lg" weight="normal" color="grey">
          {`~ ${formatTotal(Number(walletConvertedAvailable), userCurrency)}`}
        </Text>
      )}
    </>
  )
}
